<template>
    <div class="ProcessSubview">
        <QCard
            bordered
            class="ProcessSubviewCard"
        >
            <QCardSection>
                <Dashboards
                    ref="dashboards"
                    :processId="processId"
                    @drawer-state-changed="handleDrawerStateChanged"
                />
            </QCardSection>
        </QCard>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import Dashboards from '../Dashboards/Dashboards.vue'

export default {
    name: 'DashboardsSubview',
    components: { Dashboards },
    props: {
        processId: VueTypes.any,
    },
    emits: ['dashboards-drawer-state-changed'],
    methods: {
        handleDrawerStateChanged(payload) {
            this.$emit('dashboards-drawer-state-changed', payload)
        },
        reloadTabKey() {
            this.$refs.dashboards?.reloadTabKey?.()
        },

        dashboardsEnterEditMode() {
            this.$refs.dashboards?.enterEditMode?.()
        },
        dashboardsSaveEditMode() {
            this.$refs.dashboards?.saveEditMode?.()
        },
        dashboardsCancelEditMode() {
            this.$refs.dashboards?.cancelEditMode?.()
        },
        dashboardsSetSideTab(tab) {
            this.$refs.dashboards?.setSideTab?.(tab)
        },
        dashboardsAddGraph({ type, group } = {}) {
            this.$refs.dashboards?.addGraph?.({ type, group })
        },
        dashboardsUpdateTriggers({ triggers } = {}) {
            this.$refs.dashboards?.updateTriggers?.({ triggers })
        },
        dashboardsUpdateGraph(payload) {
            this.$refs.dashboards?.updateGraph?.(payload)
        },
        dashboardsRenameGraph({ name } = {}) {
            this.$refs.dashboards?.renameGraph?.({ name })
        },
    },
}
</script>

<style scoped lang="scss">
.ProcessSubview {
    height: 100%;
}

.ProcessSubviewCard {
    height: 100%;
}
</style>
